import {PopupDialogbox} from 'client/CommonComponents'

interface IProps {
    Popupcontent?:any,
    hideDialog?:any,
    popupOutlinebtnOnclick?:any,
    popupPrimarybtnOnclick?:any,
    onDismiss?:any
}
const CancelConfirmationContainer = ({popupPrimarybtnOnclick,Popupcontent,hideDialog,popupOutlinebtnOnclick}:IProps) => {
    return (
        <PopupDialogbox  hideDialog={!Popupcontent.isDialogVisible} onDismiss={hideDialog} Popupcontent={Popupcontent} popupOutlinebtnOnclick={popupOutlinebtnOnclick} popupPrimarybtnOnclick={()=>popupPrimarybtnOnclick('Home')}  data-attribute="CancelConfirmationpopup_Default_PopupDilalogBox" />
    )
}

export default CancelConfirmationContainer;